import * as React from "react"
import * as ReactDOM from "react-dom"

import Header from "../../../components/Header/index"
import TopNav from "../../../components/TopNav/index"
import "../../../components/common"
import "../../../components/shop/common"

import config from "../../../utils/config"
import request from "../../../utils/request"

export default class StoreIntro extends React.Component<any, any> {
  constructor(props: any) {
    super(props)
    this.state = {
      content: {},
      toggleKey: false,
      toggleLen: 200,
    }
  }
  public render() {
    return (
      <div>
        <Header />
        <div className="gsjs">
          <div className="store_all_top">
            <p className="name">
              <a href={this.state.content.shop_domain} target="_blank">
                {this.state.content.company_name}
              </a>
              <b>
                <img
                  src={this.state.content.shop_level_url}
                  className="icon"
                  alt=""
                />
                {this.state.content.year + "年"}
              </b>
            </p>
          </div>
          <div className="lxr">
            <div className="lxr_p">
              <em>主营产品：</em>
              <b>{this.state.content.keyword}</b>
            </div>
            <div className="lxr_p">
              <em>企业类型：</em>
              <b>{this.state.content.companyCategoryValue}</b>
            </div>
            <div className="lxr_p">
              <em>所在地：</em>
              <b>{this.state.content.city_name}</b>
            </div>
          </div>
        </div>
        <div className="gsinfo">
          <div className="gstext">
            <div>
              <div
                className="store-intro-content"
                dangerouslySetInnerHTML={{
                  __html: this.state.content.company_introduce,
                }}
              ></div>
            </div>
            {/*this.state.content.company_introduce && <div><div className="store-intro-content" dangerouslySetInnerHTML={{ __html: this.state.content.company_introduce ? this.state.content.company_introduce.substr(0, !this.state.toggleKey ? this.state.toggleLen : this.state.content.company_introduce.length) : '' }}></div></div>*/}
            {/*{
                            this.state.content.company_introduce && this.state.content.company_introduce.length > this.state.toggleLen && <em onClick={() => this.toggleAction()}>
                            {
                                !this.state.toggleKey && <b>...</b>
                            }
                            {
                                !this.state.toggleKey ? <img src={require('../../../assets/images/tz_09.png')} /> : <img src={require('../../../assets/images/tz_10.png')} />
                            }
                            </em>
                        }*/}
          </div>
        </div>
        <TopNav styleConfig={this.state.styleConfig} />
      </div>
    )
  }
  public componentDidMount() {
    this.getData()
  }
  /**
   * [getData 获取店铺介绍]
   * @return null
   */
  private async getData() {
    const id: number = (window as any).shopId
    const r = await request({
      url: config.PHPAPI + "api/wshop/shop/company-introduce",
      method: "post",
      data: {
        shopDomain: id,
      },
    })
    if (r.error_code === 0) {
      this.setState({
        content: r.data,
      })
    }
  }
  private toggleAction() {
    this.setState((state) => ({
      toggleKey: !state.toggleKey,
    }))
  }
}

ReactDOM.render(<StoreIntro />, document.getElementById("root") as HTMLElement)



// WEBPACK FOOTER //
// ./src/containers/shop/storeintro/index.tsx